import actions from "./actions";
import taiwanZipcodeData from "@/constData/taiwanZipCode.js";

export default {
  actions,
  state: {
    cartOrderNum: 0,
    specialMemberState: "",
    specialMemberData: {
      company_company_name: "",
      company_address_country: "台灣",
      company_address_county: "縣市",
      company_address_postal_code: "",
      company_address: "",
      principal_name: "",
      principal_phone: "",
      principal_email: "",
      principal_line_id: "",
    },
    renewOrderData: {},
  },
  mutations: {
    updateCartOrderNum(state, updateValue) {
      state.cartOrderNum = updateValue;
    },
    updataSingleSpecialMemberData(state, { updateKey, updateValue }) {
      state.specialMemberData[`${updateKey}`] = updateValue;
    },
    updataSpecialMemberData(state, updateValue) {
      state.specialMemberData = updateValue;
    },
    setRenewOrderData(state, orderData) {
      state.renewOrderData = orderData;
    },
  },
  getters: {
    getCartOrderNum(state) {
      return state.cartOrderNum;
    },
    getSpecialMemberState(state) {
      //null:尚未申請過，0:申請中，1:申請通過
      return state.specialMemberState;
    },
    getSpecialMemberData(state) {
      return state.specialMemberData;
    },
    getZipcode(state) {
      return state.specialMemberData.company_address_postal_code;
    },
    getCityByZipcode: (state) => (code) => {
      let city = "";
      for (var data in taiwanZipcodeData.taiwanZipcodeData) {
        for (var zipcode of taiwanZipcodeData.taiwanZipcodeData[`${data}`]) {
          for (var region in zipcode) {
            if (zipcode[`${region}`] === code) {
              city = data;
            }
          }
        }
      }
      return city;
    },
    getRegionByZipcode: (state) => (code) => {
      let regionResult = "";
      for (var data in taiwanZipcodeData.taiwanZipcodeData) {
        for (var zipcode of taiwanZipcodeData.taiwanZipcodeData[`${data}`]) {
          for (var region in zipcode) {
            if (zipcode[`${region}`] === code) {
              regionResult = region;
            }
          }
        }
      }
      return regionResult;
    },
    getrenewOrderData(state) {
      return state.renewOrderData;
    },
  },
};
